import { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Box, Flex, Image, Fade, useOutsideClick } from '@chakra-ui/react';
import PageLoader from '../../../global/components/helper-components/components/PageLoader';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { validateUrlFormat } from '../../../global/helpers/global-helpers';
import { manageSignup } from '../../actions/auth-actions';
import { useLocation } from 'react-router-dom';
import WarningTextMessage from '../../../global/components/helper-components/components/WarningTextMessage';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';


function SignupUserOrgForm({ token, userIdToken, userSetPassword, manageSignup }) {

	const formChangedRef = useRef(false);
	const location = useLocation();

	const [showValidationError, setShowValidationError] = useState(false)
	const [showLoader, setShowLoader] = useState(false);
	const [logoImageUrl, setLogoImageUrl] = useState("")
	const [showLogoImage, setShowLogoImage] = useState(false)

	const stateInstructions = new URLSearchParams(location.search).get("state")
	const isExistingInvitedUser = (stateInstructions === "invited-user-self-signup") ? true : false

	const [localUserOrgProfileState, setUserOrgProfileLocalState] = useState({
		orgWebsiteUrl: "",
		orgName: "",
		userOrgTitle: ""
	})

	const query = new URLSearchParams(location.search)
	const attributionTag =  query.get("atb")

	// Trigger to get Cb logo
	const getLogoRef = useRef(null);

	useOutsideClick({
		ref: getLogoRef,
		handler: () => handleGetCbLogo(localUserOrgProfileState),
	})

	const handleChange = (event) => {
		const name = event.target.name;
		const value = event.target.value;

		if (name === "orgName" || name === "orgWebsiteUrl" || name === "userOrgTitle") {

			setUserOrgProfileLocalState(prevState => ({
				...prevState,
				[event.target.name]: value,
				showValidationError: false
			}));

			if (!!showValidationError) {
				setShowValidationError(false)
			}

			if (!formChangedRef.current) {
				formChangedRef.current = true
			}
		}
	}

	const handleCompleteSignupProcess = () => {
		const { orgName, userOrgTitle } = localUserOrgProfileState;
		if (orgName && userOrgTitle) {

			if (!!formChangedRef.current && userIdToken && userSetPassword) {
				// Save all inputs into DB
				setShowLoader(true)

				manageSignup({
					event: 'set-password-create-org',
					payload: {
						userIdToken,
						activationToken: token,
						userSetPassword,
						orgName: orgName,
						userOrgTitle: userOrgTitle,
						...((showLogoImage === true && logoImageUrl) && { orgLogo: logoImageUrl }),
						isExistingInvitedUser,
						...(attributionTag && {attributionTag})
					}
				})
			}
		} else {
			setShowValidationError(true)
		}
	}

	const handleGetCbLogo = () => {
		const { orgWebsiteUrl } = localUserOrgProfileState || {}
		const isValidUrl = orgWebsiteUrl ? validateUrlFormat(orgWebsiteUrl) : false;

		if (isValidUrl) {
			setLogoImageUrl(`https://logo.clearbit.com/${orgWebsiteUrl}`)
		} else {
			setLogoImageUrl("")
		}
	}

	const displayLogoImage = () => {
		setShowLogoImage(true)
	}

	const hideLogoImage = () => {
		setShowLogoImage(false)
	}


	if (showLoader) {
		return (
			<PageLoader />
		)
	} else {
		const { orgName, orgWebsiteUrl, userOrgTitle } = localUserOrgProfileState || {};

		return (
			<Fade in={true}>

				<Flex w='100%' mb='0.5em' justify='center' h={showLogoImage ? "5em" : '1px'} visibility={!showLogoImage && "hidden"}>
					<Image src={logoImageUrl} onLoad={() => displayLogoImage()} onError={() => hideLogoImage()} />
				</Flex>
				{showLogoImage && <>
					<Box fontSize='0.7em' mt='1em' mb='2em' color='gray.500' px='1em' textAlign='center' display={['none', 'none', 'block', 'block']}>
						<Box>Prefer another logo? </Box>
						<Box>Change it later in account settings</Box>
					</Box>
				</>}

				<Flex my='2em' w='100%' direction='column' gap='1.5em' >


					<LaunchdeckFormInput
						label='Company website'
						name={'orgWebsiteUrl'}
						onChange={handleChange}
						value={orgWebsiteUrl}
						placeholder="e.g. https://www.my-company.com"

						ref={getLogoRef}
					/>

					<LaunchdeckFormInput
						label='Company name'
						name={'orgName'}
						onChange={handleChange}
						value={orgName}
						placeholder="e.g. My Company"
						isRequired={true}

						errorLogic={showValidationError && !orgName}
					/>

					<LaunchdeckFormInput
						label='Your position title'
						name={'userOrgTitle'}
						onChange={handleChange}
						value={userOrgTitle}
						placeholder="e.g. Customer Success Director"
						isRequired={true}

						errorLogic={showValidationError && !userOrgTitle}

					/>

				</Flex>
				<Flex justify='center' mb='0.5em'>
					<WarningTextMessage errorLogic={showValidationError} textAlign='left' message={`Please provide a Company name & your position title in it`} />
				</Flex>


				<Flex justify='center' w='100%'>
					<LaunchdeckButton bg='brand.500' color='white' w='100%' fontSize='0.875em' onClick={() => handleCompleteSignupProcess()} label='Looks good' />
				</Flex>

			</Fade>
		)
	}
};


function mapStateToProps(state) {
	return {
		signupOutcome: state.auth.data.signup.results
	};
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			manageSignup
		},
		dispatch,
	)

export default connect(mapStateToProps, mapDispatchToProps)(SignupUserOrgForm);
